import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CdsInputsModule } from '@celerofinancas/design-system';
import { TooltipDirective } from '@celerofinancas/ui-directives';
import { OAuthService } from '@celerofinancas/ui-oauth';

/**
 * design-system
 */
@Component({
  selector: 'caixa-webcomponent-design-system',
  templateUrl: './design-system.component.html',
  standalone: true,
  imports: [
    CdsInputsModule,
    TooltipDirective
  ],
  styleUrls: ['./design-system.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesignSystemComponent implements OnInit {
  /**
   * OAuth service
   */
  private readonly oauth = inject(OAuthService);

  /**
   * On init
   */
  public ngOnInit(): void {
    this.oauth.loadConfiguration();
    this.oauth.getToken({});
  }

  /**
   * Initialize login flow
   */
  public initLogin(): void {
    this.oauth.initLoginFlow(false);
  }
}
